import ContactFormWidget from "./ContactFormWidget";
import InfoBoxWidget from "./InfoBoxWidget";
import MapWidget from "./MapWidget";

function ContactFormSection() {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          Contact For Any Query
        </h1>
        <div className="row g-4">
          <div className="col-12">
            <div className="row gy-4">
              <InfoBoxWidget />
            </div>
          </div>
          <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <MapWidget />
          </div>
          <div className="col-md-6">
            <ContactFormWidget />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactFormSection;
